import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import { loadConfig } from '@shared/services/config'
import App from './App.tsx'

// Load runtime configuration before rendering so that getConfig() / getMsalInstance()
// have access to resolved values synchronously.
loadConfig().then(() => {
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <App />
    </StrictMode>,
  )
})
